import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import ImageInput from './image-input'
import ImagePreview from './image-preview'
import { cropperSelect, cropperReset } from 'actions/cropper'
import { getImagePreview, isUploadingImage, isValidatingImage } from 'selectors/setupform'

export class ImageInputContainer extends Component {

  constructor(props) {
    super(props)

    this.handleImageChange = this.handleImageChange.bind(this)
  }

  handleImageChange(e) {
    this.props.data.onChange(e)

    if (e.target.files.length) {
      this.props.cropperSelect(e.target.files.item(0))
    }
  }

  render() {
    return this.props.imagePreview ?
      <ImagePreview
        isUploadingImage={this.props.isUploadingImage}
        isValidatingImage={this.props.isValidatingImage}
        imagePreview={this.props.imagePreview}
        onClick={this.props.cropperReset}
      />
      : <ImageInput {...this.props} onChange={this.handleImageChange} />
  }

}

ImageInputContainer.propTypes = {
  isUploadingImage: PropTypes.bool,
  isValidatingImage: PropTypes.bool,
  imagePreview: PropTypes.string,
  cropperReset: PropTypes.func,
  cropperSelect: PropTypes.func,
  data: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  imagePreview: getImagePreview(state),
  isUploadingImage: isUploadingImage(state),
  isValidatingImage: isValidatingImage(state),
})

const mapDispatchToProps = { cropperSelect, cropperReset }

export default connect(mapStateToProps, mapDispatchToProps)(ImageInputContainer)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/image-input/image-input-container.js
 **/